import { z } from "zod";

export const HelpSchema = z.object({
  text: z.string(),
  url: z.string(),
});

export const HelpdeskSchema = z.object({
  variants: HelpSchema.optional(),
});

export type IHelp = z.infer<typeof HelpSchema>;
export type IHelpdesk = z.infer<typeof HelpdeskSchema>;
